// extracted by mini-css-extract-plugin
export default {"container":"articles_container__11So0","inner":"articles_inner__3DQcT","isContainer":"articles_isContainer__t5T4y","grid":"articles_grid__2zraI","list":"articles_list__35Xi0"};